import { Grid, TextField, Typography } from "@mui/material";
import { useAppSelector } from "../../app/store/configureStore";
import ReadMoreReadLess from "../../app/common/ReadMoreReadLess";
import { AnswersProps } from "../../app/models/Answers";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  textbox: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const ChallengingBehaviors: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const { user } = useAppSelector((state) => state.account);

  const isHomeVisitor = user?.credentialTypeId === 4;
  const firstSystemCodeId = isHomeVisitor ? 178 : 179;

  const defaultValues = {
    firstTextBox: answersData.find(
      (answer) => answer.systemCodeId === firstSystemCodeId
    )?.answer,
  };

  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const renderHandlingChallengingBehaviorsCompetence = () => {
    return (
      <ul>
        <li>
          What activities and materials do you incorporate daily to encourage
          social interactions?
        </li>
        <li>
          How are activities adapted to meet the individual needs of all
          children?
        </li>
        <li>
          How do you create opportunities that allow recognition and
          appreciation of multiple cultural groups, ethnicities, and family
          structures?
        </li>
        <li>
          How do you ensure the classroom environment provides opportunities for
          children to work and play in harmony?
        </li>
        <li>
          What strategies do you use to help children experience
          sympathy/empathy and respect for others?
        </li>
      </ul>
    );
  };

  const renderHandlingChallengingBehaviorsCompetence2 = () => {
    return (
      <ul>
        <li>
          What practices are implemented to include small and large group
          activities?
        </li>
        <li>
          What activities and materials do you incorporate daily to encourage
          social interactions?
        </li>
        <li>
          How do you create opportunities that allow recognition and
          appreciation of multiple cultural groups, ethnicities, and family
          structures?
        </li>
        <li>
          What strategies do you use to help children experience
          sympathy/empathy and respect for others?
        </li>
        <li>
          What modifications are made to support all abilities within the
          environment?
        </li>
      </ul>
    );
  };

  const renderHandlingChallengingBehaviorsCompetence3 = () => {
    return (
      <ul>
        <li>
          What steps have you implemented to ensure the home environment
          provides opportunities for children to experience cooperation?
        </li>
        <li>
          What resources and materials have you used to help parents promote
          feelings of empathy and respect for others?
        </li>
        <li>
          What strategies have you employed to help parents understand the
          typical social behaviors for children?
        </li>
        <li>
          How do partner with families to ensure diverse activities, materials,
          curriculum and/or events reflect an understanding of others’ cultures
          and the value of a non-bias and anti-bias environment?
        </li>
      </ul>
    );
  };

  return (
    <>
      <Grid container bgcolor={"comp3.light"} pb={3}>
        <Grid item xs={12} px={3} pt={3}>
          <Typography variant="body1" fontWeight={"bold"} paragraph>
            Handling Challenging Behaviors
          </Typography>
          <Typography variant="body1" paragraph>
            {user?.credentialTypeId !== 4
              ? "How do you deal constructively with young children's challenging behaviors?"
              : "How do you teach families to deal with their children's challenging behaviors constructively?"}
          </Typography>

          {user?.credentialTypeId === 3 ? (
            <ReadMoreReadLess>
              {renderHandlingChallengingBehaviorsCompetence()}
            </ReadMoreReadLess>
          ) : user?.credentialTypeId === 4 ? (
            <ReadMoreReadLess>
              {renderHandlingChallengingBehaviorsCompetence3()}
            </ReadMoreReadLess>
          ) : (
            <ReadMoreReadLess>
              {renderHandlingChallengingBehaviorsCompetence2()}
            </ReadMoreReadLess>
          )}
        </Grid>
        <Grid item xs={12} px={3} pt={3}>
          <TextField
            label={
              user?.credentialTypeId !== 4
                ? "I deal with young children's challenging behavior by"
                : "I teach families to deal with their children's challenging behaviors constructively by"
            }
            multiline
            rows={2}
            fullWidth
            {...register("firstTextBox")}
            name="firstTextBox"
            sx={{ bgcolor: "white" }}
            value={
              answersData.find(
                (answer) => answer.systemCodeId === firstSystemCodeId
              )?.answer || ""
            }
            onChange={(e) => {
              const newValue = e.target.value;
              const systemCodeId = firstSystemCodeId;

              newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
            }}
            error={!!errors.firstTextBox?.message}
            helperText={errors.firstTextBox?.message}
          />
          <Typography fontSize={13}>
            {defaultValues.firstTextBox?.length}/500
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
export default ChallengingBehaviors;
